import React from "react";
import {
  Drawer,
  Box,
  Typography,
  Divider,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Stack,
} from "@mui/material";
import DocumentItem from "../../Components/Masters/DocumentItem";

const GenericViewDrawer1 = ({
  open,
  onClose,
  title,
  fields = [],
  documentsField = null,
  timeline = [],
  editRemarkReason = "",
  onApprove,
  onReject,
}) => {
  const renderValue = (val) => (val !== undefined && val !== null ? val : "—");

  /** API may return a single path string or an array; keep chip layout consistent in both table cells. */
  const normalizeDocList = (docs) => {
    if (!docs) return [];
    if (Array.isArray(docs)) return docs.filter(Boolean);
    if (typeof docs === "string" && docs.trim()) return [docs.trim()];
    return [];
  };

  const renderDocuments = (docs) => {
    const list = normalizeDocList(docs);
    return list.length > 0 ? (
      list.map((url, index) => <DocumentItem key={`${url}-${index}`} url={url} />)
    ) : (
      "—"
    );
  };

  const getLastTimelineEntry = () => {
    const lastArray = [...timeline].reverse().find((arr) => Array.isArray(arr) && arr.length);
    return lastArray?.[lastArray.length - 1] || null;
  };

  const lastEntry = getLastTimelineEntry();
  const timestamp = lastEntry ? new Date(lastEntry.timeStamp) : null;

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box width="90vw" maxWidth={1000} p={3}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          {title}
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <TableContainer component={Paper} sx={{ mb: 3 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell><strong>Field</strong></TableCell>
                <TableCell><strong>Previous</strong></TableCell>
                <TableCell><strong>Requested</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {fields.map((field, idx) => (
                <TableRow key={idx}>
                  <TableCell>{field.label}</TableCell>
                  <TableCell>{renderValue(field.previous)}</TableCell>
                  <TableCell>{renderValue(field.requested)}</TableCell>
                </TableRow>
              ))}

              {documentsField && (
                <TableRow>
                  <TableCell>{documentsField.label}</TableCell>
                  <TableCell sx={{ verticalAlign: "top" }}>
                    <Box
                      display="flex"
                      flexWrap="wrap"
                      gap={1}
                      alignItems="flex-start"
                    >
                      {renderDocuments(documentsField.previous)}
                    </Box>
                  </TableCell>
                  <TableCell sx={{ verticalAlign: "top" }}>
                    <Box
                      display="flex"
                      flexWrap="wrap"
                      gap={1}
                      alignItems="flex-start"
                    >
                      {renderDocuments(documentsField.requested)}
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Box display="flex" flexDirection="column" gap={1}>
          {lastEntry ? (
            <>
              <Typography variant="body2">
                <strong>Created By:</strong> {lastEntry?.name || "—"}
              </Typography>
              <Typography variant="body2">
                <strong>Remark Reason:</strong> {editRemarkReason || "—"}
              </Typography>
              <Typography variant="body2">
                <strong>Date:</strong> {timestamp.toLocaleDateString("en-IN")}
              </Typography>
              <Typography variant="body2">
                <strong>Time:</strong>{" "}
                {timestamp.toLocaleTimeString("en-IN", {
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                })}
              </Typography>
            </>
          ) : (
            <Typography variant="body2">No timeline history available</Typography>
          )}
        </Box>

        <Stack direction="row" spacing={2} mt={4} justifyContent="flex-end">
          <Button variant="contained" color="success" onClick={onApprove}>
            Approve
          </Button>
          <Button variant="outlined" color="error" onClick={onReject}>
            Reject
          </Button>
        </Stack>
      </Box>
    </Drawer>
  );
};

export default GenericViewDrawer1;
